export interface Category {
  name: string;
  icon: string;
  tone: string;
  desc: string;
}

export const brand = {
  name: "热瓜雷达",
  slogan: "把全网热瓜摆在同一张桌上",
  email: "editor@regan-radar.example",
};

export const categories: Category[] = [
  { name: "合约风波", icon: "ri-file-text-line", tone: "bg-primary-100 text-primary-700", desc: "解约、合约条款与法务动向" },
  { name: "塌房现场", icon: "ri-collapse-diagonal-line", tone: "bg-accent-100 text-accent-700", desc: "人设崩塌的一夜反转" },
  { name: "综艺幕后", icon: "ri-film-line", tone: "bg-secondary-100 text-secondary-800", desc: "剪辑、剧本与番位争议" },
  { name: "粉圈大战", icon: "ri-team-line", tone: "bg-primary-100 text-primary-700", desc: "饭圈battle与应援互撕" },
  { name: "考古回放", icon: "ri-history-line", tone: "bg-accent-100 text-accent-700", desc: "旧照旧帖被扒的连锁反应" },
  { name: "假唱红黑", icon: "ri-mic-2-line", tone: "bg-secondary-100 text-secondary-800", desc: "舞台真唱与假唱界定" },
  { name: "海外瓜田", icon: "ri-earth-line", tone: "bg-primary-100 text-primary-700", desc: "海内外热瓜联动观察" },
  { name: "资本内幕", icon: "ri-coin-line", tone: "bg-accent-100 text-accent-700", desc: "资本与流量背后的角力" },
];

export const stats = [
  { value: "128", label: "已梳理专题", icon: "ri-archive-2-line" },
  { value: "46", label: "事件时间线", icon: "ri-timeline-view" },
  { value: "32", label: "对比分析手册", icon: "ri-scales-3-line" },
  { value: "12", label: "周均更新(篇)", icon: "ri-refresh-line" },
];

export interface Testimonial {
  quote: string;
  name: string;
  role: string;
}

export const testimonials: Testimonial[] = [
  {
    quote: "最怕热瓜吃到一半断章取义，这里能把同类剧情拉出来逐条对照，脉络一下就清楚了。",
    name: "追更三年的网友·阿黎",
    role: "普通吃瓜群众",
  },
  {
    quote: "时间线串联是真做得好，声明、回应、粉丝动作都按日期摆好，不给人带节奏的机会。",
    name: "自媒体作者·清欢",
    role: "内容创作者",
  },
  {
    quote: "写对比选题前都会来这里找同类案例库，省了我大量搜集资料的时间。",
    name: "娱乐号主理·北辰",
    role: "泛娱乐编辑",
  },
];